// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f416db7c","632":"7cc10e63"}[chunkId] + ".chunk.js";
};